import React from 'react';
import { TAP, useThemeMode, getTheme } from '../../theme';
import { baseButton } from './shared';

/**
 * Reglage 40×22 med knopp 16 (samma som marknadsplatsens Mörkt-reglage), tryckyta minst 44 px hög.
 * Utan `label` krävs `ariaLabel`.
 */
export function Switch({ checked, onChange, label, ariaLabel, labelPosition = 'left', disabled, color, style }: {
  checked: boolean; onChange: (v: boolean) => void;
  label?: React.ReactNode; ariaLabel?: string; labelPosition?: 'left' | 'right';
  disabled?: boolean; color?: string; style?: React.CSSProperties;
}) {
  const { mode } = useThemeMode();
  const T = getTheme(mode);
  const off = mode === 'dark' ? 'rgba(241,242,233,0.22)' : '#c9ccbf';
  const text = label && <span>{label}</span>;
  return (
    <button
      type="button" role="switch" aria-checked={checked} aria-label={ariaLabel} disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        ...baseButton, gap: 8, background: 'none', padding: 0, minHeight: TAP, minWidth: TAP,
        color: color ?? T.textSub, fontSize: 14, fontWeight: 600, opacity: disabled ? 0.5 : 1, ...style,
      }}
    >
      {labelPosition === 'left' && text}
      <span aria-hidden style={{ width: 40, height: 22, borderRadius: 999, background: checked ? T.accentFill : off, position: 'relative', transition: 'background .25s', flexShrink: 0 }}>
        <span style={{ position: 'absolute', top: 3, left: 3, width: 16, height: 16, borderRadius: '50%', background: '#fff', boxShadow: '0 1px 2px rgba(0,0,0,0.25)', transform: `translateX(${checked ? 18 : 0}px)`, transition: 'transform .25s' }} />
      </span>
      {labelPosition === 'right' && text}
    </button>
  );
}
